export default "__VITE_ASSET__2FO0I1jq__"